import { render, staticRenderFns } from "./ElementForm.vue?vue&type=template&id=25cdde50&scoped=true"
import script from "./ElementForm.vue?vue&type=script&lang=js"
export * from "./ElementForm.vue?vue&type=script&lang=js"
import style0 from "./ElementForm.vue?vue&type=style&index=0&id=25cdde50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cdde50",
  null
  
)

export default component.exports